function processSelectItem(container, menu, menuItem, seletedItem) {
  const flag = menuItem.getAttribute("data-flag");
  const code = menuItem.getAttribute("data-phone-code");
  seletedItem.querySelector(".selected--flag").innerHTML = `<img class="sprite_flags_${flag.toLocaleLowerCase()}">`;
  seletedItem.querySelector(".selected--code").textContent = code;
  container.parentNode.querySelector("input[name='enquiry[phone_country_code]']").setAttribute('value', flag.toLocaleUpperCase());
  container.querySelector('input.phone').focus();
  menu.classList.add("hide");
}

function handleMenuClick(container, menu, seletedItem) {
  menu.addEventListener("click", e => {
    e.preventDefault();
    e.stopPropagation();
    const liTag = e.target.closest("li");
    processSelectItem(container, menu, liTag, seletedItem);
  });
}

function handleDropdownClick(dropdown, menu) {
  dropdown.addEventListener("click", () => {
    menu.classList.toggle("hide");
  });
}

function handleOutSideClick(dropdown) {
  document.body.addEventListener("click", (e) => {
    if (!dropdown.contains(e.target)) {
      const menu = dropdown.querySelector('ul');
      menu.classList.add("hide");
    }
  });
}

function initDropdownEvents(containers) {
  containers.forEach(container => {
    const dropdown = container.querySelector(".country-dropdown");
    const menu = dropdown.querySelector("ul");
    const selectedItem = dropdown.querySelector(".country-dropdown__seleted");

    handleDropdownClick(dropdown, menu);
    handleMenuClick(container, menu, selectedItem);
    handleOutSideClick(container);
  });
}

export default initDropdownEvents



// WEBPACK FOOTER //
// ./shared/helpers/dropdown_phone_code.js